import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  HStack,
  Button,
  IconButton,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { AddOutlined } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';

const FileLibraryTopButton = ({onOpen, setIsOpenAction, isButtonDisabled}) => {
    const location = useLocation();

    const triggerCreateFolder = () => {
        setIsOpenAction("create-folder");
        onOpen();
    }

    const triggerUploadFile = () => {
        setIsOpenAction("upload-file");
        onOpen();
    }

    return (
        <Tooltip 
            label="Cannot add files and folders here" 
            placement="bottom"
            offset={[-30, -3]}
            isDisabled={!isButtonDisabled}
        >
        <span>
            <Menu placement="bottom" justify={"flex-end"} offset={[0, 0]}>
            <MenuButton 
                as={Button} 
                bgColor={"#2584FD"}
                _hover={{ bgcolor: "#2584FD" }}
                _active={{ bgcolor: "#2584FD" }}
                height={"40px"}
                width={"120px"}
                disabled={isButtonDisabled}
            >
                <HStack spacing={0} align="center" justify="center">
                <IconButton
                    width={"24px"}
                    sx={{padding: 0, bgColor: "transparent", "&:hover": {backgroundColor: "transparent"}}}
                >
                    <AddOutlined
                    sx={{ padding: 0, fontSize: 20, color: "white", bgColor: "transparent" }}
                    />
                </IconButton>
                <Text color={"white"} fontSize={"16px"}>
                    New
                </Text>
                </HStack>
            </MenuButton>
            <MenuList minW="unset" width={"156px"}>
                <MenuItem onClick={triggerCreateFolder}>Create Folder</MenuItem>
                <MenuItem onClick={triggerUploadFile}>Upload File</MenuItem>
            </MenuList>
            </Menu>
        </span>
        </Tooltip>

    )
}

export default FileLibraryTopButton;